import { type CsticId } from "~/Configurators/Linear/models";
import { type SubstepType } from "~/Configurators/Linear/dtos";
import { type RootState } from "~/redux/store";
import { getCsticMapFromNested } from "~/Configurators/Linear/redux/selectors";
import { getDirtyParamName } from "~/Configurators/Linear/namingUtils";
import type { LinearConfiguratorState } from "~/Configurators/Linear/redux/types";

export const selectCsticExpanded = (csticId: CsticId, substep: SubstepType) => (state: RootState) =>
  selectCsticExpandedFromNested(csticId, substep)(state.linearConfigurator);

export const selectCsticExpandedFromNested =
  (csticId: CsticId, substep: SubstepType) => (state: LinearConfiguratorState) => {
    const cstic = selectCsticFromNested(csticId)(state);

    const stepDef = state.substeps[substep];
    const isInConflict = state.conflicts.some((conflict) =>
      conflict.cstics.find((cstic) => cstic.name === csticId.key)
    );
    const isDirty: boolean = stepDef.additionalData[getDirtyParamName(csticId)] ?? false;

    return {
      cstic,
      isInConflict,
      isDirty,
    };
  };

export const selectCstic = (csticId: CsticId) => (state: RootState) =>
  selectCsticFromNested(csticId)(state.linearConfigurator);

export const selectCsticFromNested = (csticId: CsticId) => (state: LinearConfiguratorState) => {
  const csticMap = getCsticMapFromNested(csticId.type, csticId.index)(state);
  return csticMap[csticId.key];
};
